
// (function () {
//   if ('scrollRestoration' in history) {
//     history.scrollRestoration = 'manual';
//   }

//   window.addEventListener('pageshow', function (e) {
//     if (e.persisted) {
//       location.reload();
//     }
//   });

//   window.addEventListener('popstate', function () {
//     location.reload();
//   });
// })();



(function () {

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function forceReload() {
    window.location.href = window.location.href.split('#')[0];
  }

  // back-forward cache restore
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      forceReload();
    }
  });

  // browser back/forward
  window.addEventListener('popstate', function () {
    forceReload();
  });

  // Safari + mobile extra fix
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      const nav = performance.getEntriesByType('navigation')[0];

      if (nav && nav.type === 'back_forward') {
        forceReload();
      }
    }
  });

})();
